import { Col, Row } from "reactstrap"

const PerformanceOverTime = () => {

  const data = [
    { name: 'Impressions Over Time', content: 'Impressions Line Chart' },
    { name: 'Clicks Over Time', content: 'Clicks Line Chart' },
    { name: 'Sales Over Time', content: 'Sales Line Chart' },
    { name: 'Spend Over Time', content: 'Spend Line Chart' },
    { name: 'Top Performing Products', content: '' },
    { name: 'Top Performing Keywords', content: '' },
  ]

  return (
    <section>
      <div className="fw-semibold fs-4 my-3">Performance Over Time</div>
      
      <Row className="gy-3">

        {data.map(item => (
          <Col xs='12' lg='6'>

            <div className="text-center bg-white rounded py-3">
              <div className="fw-semibold">{item.name}</div>
              <div className="p-5">{item.content}</div>
            </div>

          </Col>
        ))}

      </Row>

    </section>
  )
}

export default PerformanceOverTime
